import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import SignIn from "./components/session/SignIn";
import ForgotPassword from "./components/session/ForgotPassword";
import Mobile from "./components/session/Mobile";
import RegisterNow from "./components/session/RegisterNow";
import RequestInformation from "./components/session/RequestInformation";
import ResetPassword from "./components/session/ResetPassword";

import Home from "./components/home/Home";
import MyFavourites from "./components/myFavourites/MyFavourites";
import NutritionHome from "./components/nutrition/home/NutritionHome";
import RecipesListing from "./components/nutrition/recipes/listing/RecipesListing";
import RecipeDetails from "./components/nutrition/recipes/details/RecipeDetails";
import FoodDatabase from "./components/nutrition/foodDatabase/FoodDatabase";
import FoodApproval from "./components/nutrition/foodDatabase/foodApproval";
import FoodDetails from "./components/nutrition/foodDatabase/viewFoodItem";
import AddRecipe from "./components/nutrition/recipes/add/AddRecipe";
import ResourcesListing from "./components/nutrition/resources/ResourcesListing";
import NutritionJournal from "./components/nutrition/journal/JournalListing";
import AddFoodItem from "./components/nutrition/foodDatabase/add/AddFoodItem";
import RecipeComments from "./components/nutrition/recipes/recipeComments";

import MyFood from "./components/nutrition/myFood/MyFood";

import FitnessHome from "./components/fitness/home/FitnessHome";
import WorkoutPlans from "./components/fitness/workoutPlans/WorkoutPlanListing";
import WorkoutDetails from "./components/fitness/workoutPlans/viewWorkoutPlan";
import ExerciseListing from "./components/fitness/exercise/ExerciseListing";
import ExerciseDetails from "./components/fitness/exercise/exerciseDetails";
import MyWorkout from "./components/fitness/myWorkout/MyWorkoutListing";
import MyProgressListing from "./components/fitness/myProgress/MyProgressListing";
import MyHistory from "./components/fitness/myHistory/MyHistoryListing";

import ProgressPage from "./components/progress/Progress";
import FitnessJournal from "./components/fitness/journal/FitnessJournalListing";
import AdsPage from "./components/adManagement/AdManagement";
import MotivationManagement from "./components/motivationalContentManagement/MotivationManagement";
import BadgeListing from "./components/badges/BadgeListing";
import TestimonialListing from "./components/testimonials/TestimonialListing";

import ReferAFriend from "./components/referFriend/ReferFriend";

import AdminTestimonialApproval from "./components/testimonials/adminApproveTestimonial";
import FoodApprovalDetails from "./components/nutrition/foodDatabase/viewPatientFoodItem";

export function MainRouter() {
	return (
		<Switch>
			<Route exact path="/home" component={Home} />
			<Route exact path="/my-favourites" component={MyFavourites} />
			<Route exact path="/nutrition" component={NutritionHome} />
			<Route exact path="/nutrition/home" component={NutritionHome} />
			<Route exact path="/nutrition/recipes/:id/add" component={AddRecipe} />
			<Route exact path="/nutrition/recipes/:id/edit" component={AddRecipe} />
			<Route exact path="/nutrition/recipes/add" component={AddRecipe} />
			<Route exact path="/nutrition/recipes/comments" component={RecipeComments} />
			<Route exact path="/nutrition/recipes/approval" component={RecipesListing} />
			<Route exact path="/nutrition/recipes" component={RecipesListing} />
			<Route exact path="/nutrition/recipes/:id/details" component={RecipeDetails} />
			<Route exact path="/nutrition/food-database" component={FoodDatabase} />
			<Route exact path="/nutrition/food-database/approval" component={FoodApproval} />
			<Route exact path="/nutrition/food-database/:id/details" component={FoodDetails} />
			<Route exact path="/nutrition/food-database/approval/:id/details" component={FoodApprovalDetails} />
			<Route exact path="/nutrition/food-database/add" component={AddFoodItem} />
			<Route exact path="/nutrition/food-database/:id/add" component={AddFoodItem} />
			<Route exact path="/nutrition/food-database/approval/:id/add" component={AddFoodItem} />
			<Route exact path="/nutrition/food-database/:id/edit" component={AddFoodItem} />
			<Route exact path="/nutrition/food-database/approval/:id/edit" component={AddFoodItem} />
			<Route exact path="/nutrition/resources" component={ResourcesListing} />
			<Route exact path="/nutrition/resources/:id/details" component={ResourcesListing} />
			<Route exact path="/nutrition/journal" component={NutritionJournal} />
			<Route exact path="/nutrition/myfood" component={MyFood} />
			<Route exact path="/nutrition/myfood/add" component={AddFoodItem} />
			<Route exact path="/nutrition/myfood/:id/edit" component={AddFoodItem} />
			<Route exact path="/nutrition/food-database/:id/view" component={AddFoodItem} />
			<Route exact path="/fitness" component={FitnessHome} />
			<Route exact path="/fitness/home" component={FitnessHome} />
			<Route exact path="/fitness/workout-plans" component={WorkoutPlans} />
			<Route exact path="/fitness/workout-plans/:id/details" component={WorkoutDetails} />
			<Route exact path="/fitness/exercises" component={ExerciseListing} />
			<Route exact path="/fitness/exercises/:id/details" component={ExerciseDetails} />
			<Route exact path="/fitness/my-workout" component={MyWorkout} />
			<Route exact path="/fitness/my-progress" component={MyProgressListing} />
			<Route exact path="/fitness/my-history" component={MyHistory} />
			<Route exact path="/fitness/journal" component={FitnessJournal} />

			<Route exact path="/progress" component={ProgressPage} />
			<Route exact path="/fitness/journal" component={FitnessJournal} />
			<Route exact path="/ads" component={AdsPage} />
			<Route exact path="/motivational-content" component={MotivationManagement} />
			<Route exact path="/my-badges" component={BadgeListing} />
			<Route exact path="/testimonials" component={TestimonialListing} />
			<Route exact path="/testimonials/:id/edit" component={AdminTestimonialApproval} />

			<Route exact path="/refer-a-friend" component={ReferAFriend} />

			<Redirect to="/home" />
		</Switch>
	);
}

export function SessionRouter() {
	return (
		<Switch>
			<Route exact path="/signin" component={SignIn} />
			<Route exact path="/mobile" component={Mobile} />
			<Route exact path="/forgot-password" component={ForgotPassword} />
			<Route exact path="/register" component={RegisterNow} />
			<Route
				exact
				path="/request-information"
				render={({ history }) => (
					<RequestInformation
						initialValues={{ subject: "Request Information" }}
						title="Request Information"
						history={history}
					/>
				)}
			/>
			<Route
				exact
				path="/schedule-an-appointment"
				render={({ history }) => (
					<RequestInformation
						initialValues={{ subject: "Schedule an Appointment" }}
						title="Schedule an Appointment"
						history={history}
					/>
				)}
			/>
			<Route exact path="/reset-password-request" component={ResetPassword} />
			<Redirect to="/signin" />
		</Switch>
	);
}
